import { render } from "./CreateBoat.vue?vue&type=template&id=37fb25bd&scoped=true"
import script from "./CreateBoat.vue?vue&type=script&lang=js"
export * from "./CreateBoat.vue?vue&type=script&lang=js"

import "./CreateBoat.vue?vue&type=style&index=0&id=37fb25bd&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fb25bd"]])

export default __exports__